"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createActivityStyle;

function createActivityStyle(_ref) {
  var paddingRegular = _ref.paddingRegular;
  return {
    marginBottom: paddingRegular,
    '&:first-child': {
      marginTop: paddingRegular
    }
  };
}